/**
 * Author:hong.rong
 * Desc:从网盘选择
 * Date:2022-09-15
 */

import React, { useState } from 'react'
import isFunction from 'lodash/isFunction'
import { useTranslation } from '@/libs/next-lang'
import { useModalWrap } from '@/components'
import PanLibrary from './PanLibrary'
import { getDirInfo } from './services'
require('./index.less')

interface IProps {
  accept?: string[]
  libProps?: Record<string, any>
  modalProps?: Record<string, any>
  onOk: (...args: any) => any
  children: (onShow: () => void) => JSX.Element
}
const PanModal = ({
  accept = ['jpg', 'jpeg', 'png', 'mp4', 'mov'],
  libProps = {},
  modalProps = {},
  onOk,
  children,
}: IProps) => {
  const [selectedFiles, setSelectedFiles] = useState([])

  const { t } = useTranslation(['components'])

  // React.useEffect(() => {
  //   showModal()
  // }, [])

  const handlePanOk = () => {
    if (isFunction(onOk)) {
      return onOk(selectedFiles)
    }
    return false
  }

  /**
   * 从网盘选择
   * @param list
   */
  const handlePanChange = (list: any) => {
    setSelectedFiles(list)
  }

  const { showModal, render } = useModalWrap({
    modalProps: {
      width: 980,
      title: t('components:panDisk.t1'),
      cancelText: t('components:t85'),
      okText: t('components:t59'),
      ...modalProps,
      wrapClassName: 'pan-modal-wrap',
      onOk: handlePanOk,
      okButtonProps: {
        disabled: !selectedFiles.length,
      },
    },
    children: () => (
      <PanLibrary
        accept={accept}
        fileListParams={libProps}
        getFilesList={getDirInfo}
        onChange={handlePanChange}
        translateTxt={t}
      />
    ),
  })

  return (
    <React.Fragment>
      {children && children(showModal)}
      {render()}
    </React.Fragment>
  )
}
export default PanModal
